// @ts-check
import { Modal } from 'antd';
import FormPreview from '~/components/AdminPages/ManageForms/FormPreview';

export default function FormPreviewModal({ show, cancel, form_uuid, fields, title }) {
    return (
        <Modal
            width={830}
            title="Preview"
            open={show}
            maskClosable={false}
            onCancel={cancel}
            footer={null}
            maskTransitionName="maskTransitionName"
        >
            <FormPreview formId={form_uuid} fields={fields} title={title} />
        </Modal>
    )
}
